import { preload } from 'swr';
import useSWRImmutable from 'swr/immutable';
import noErrorFetcher from './shared/noErrorFetcher';

const config = {
  url: '/prequals/prefills',
  params: {
    prefillId: new URLSearchParams(window.location.search).get('prefillId'),
  },
};

const usePrefill = () => useSWRImmutable(config, noErrorFetcher, { suspense: true });

preload(config, noErrorFetcher);

export default usePrefill;
